export default __webpack_public_path__ + "static/media/less-icon-black.a5f5335f.svg";